
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeavePolicyDetailsDialog extends Serenity.EntityDialog<LeavePolicyDetailsRow, any> {
        protected getFormKey() { return LeavePolicyDetailsForm.formKey; }
        protected getIdProperty() { return LeavePolicyDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return LeavePolicyDetailsRow.localTextPrefix; }
        protected getService() { return LeavePolicyDetailsService.baseUrl; }
        protected getDeletePermission() { return LeavePolicyDetailsRow.deletePermission; }
        protected getInsertPermission() { return LeavePolicyDetailsRow.insertPermission; }
        protected getUpdatePermission() { return LeavePolicyDetailsRow.updatePermission; }

        protected form = new LeavePolicyDetailsForm(this.idPrefix);

    }
}